<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">GAAU's</strong>
              <a
                v-permission="'Inventario.Adicionar'"
                class="ml-auto btn btn-primary"
                href="/#/gaau/novo"
                title="Adicionar novo GAAU"
              >
                Adicionar
              </a>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Projeto</label>
                  <v-select
                    placeholder="Digite o nome do projeto"
                    v-model="project"
                    :options="projects"
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <button class="btn btn-secondary mt-4" @click="Filter">
                  Filtrar
                </button>
              </div>
            </div>
            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              empty-text="Nenhum GAAU encontrado."
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(isGaau)="data">
                <div class="center">
                  <span v-if="data.item.isGaau" class="badge badge-success">
                    Sim
                  </span>
                  <span v-else class="badge badge-secondary">Não</span>
                </div>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <b-button
                    variant="warning"
                    style="margin-right: 10px"
                    title="Editar"
                    @click="Edit(data.item)"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    title="Remover"
                    @click="Remove(data.item)"
                    v-permission="'Gaau.Remover'"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <b-modal
              v-model="modalRemover"
              title="Confirmar exclusão"
              class="modal-danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              Você confirma a exclusão desse registro?
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import GaauService from "../../servico/GaauService";
import ProjectService from "../../servico/ProjectService";

export default {
  name: "Gaau",
  components: {
    RotateSquare
  },
  data() {
    return {
      project: {},
      projects: [],
      modalRemover: false,
      itemRemover: null,
      loading: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 20,
      fields: [
        { key: "project", label: "Projeto", sortable: true },
        { key: "commonName", label: "Nome Comum", sortable: true },
        { key: "scientificName", label: "Nome Científico", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  watch: {
    pagina: function (val) {
      this.GetGrid(val);
    }
  },
  beforeMount() {
    this.GetGrid(1);
  },
  mounted() {
    this.OnSearchProjects("    ");
  },
  methods: {
    Edit(item) {
      this.$router.push("/gaau/editar/" + item.id);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      GaauService.Remove(this.itemRemover.id)
        .then(() => {
          this.GetGrid(1);
          this.$notify({
            data: ["GAAU removido com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Remove(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    GetGrid(pagina, projectId) {
      this.loading = true;

      GaauService.GetGrid(pagina, projectId)
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    OnSearchProjects(term) {
      if (!term || term.length <= 2) return;

      ProjectService.GetVSelect(term, true)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Filter() {
      if (this.project && this.project.id) this.GetGrid(1, this.project.id);
      else this.GetGrid(1, null);
    }
  }
};
</script>
